module.exports = __webpack_public_path__ + "img/iconXiTongYongHuLieBiao.428a0788.svg";